import { FormikProvider } from 'formik';
import { equals, path } from 'ramda';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { updateCompany } from '../../../modules/company/companyActions';
import useDetectDiffInChanges from '../../../utils/hooks/useDetectDiffInChanges';
import { useForm } from '../../../utils/hooks/useForm';
import { DisplayFlexS } from '../../../utils/stylesHelpers';

import FieldComment from './common/fieldComment';
import SaveBtn from './common/saveBtn';
import SelectsArray from './common/selectsArray';
import { SaveButtonWrapper } from './companyEditS';

const getInitialValues = ({ company, staticCompanyValues }) => ({
  industries:
    !company.industries || !company.industries.length
      ? ['']
      : path(['industries'], company).filter((item) => staticCompanyValues.industries.includes(item)),
});

const IndustrySettings = ({ isAdmin, setActiveSettingType }) => {
  const dispatch = useDispatch();

  const company = useSelector((state) => state.company.companyItem);
  const loading = useSelector((state) => state.company.loading);
  const staticCompanyValues = useSelector((state) => state.app.staticCompanyValues);

  const initialValues = getInitialValues({ company, staticCompanyValues });

  const handleSubmit = (values) => {
    const industries = values.industries.filter((i) => !!i.trim().length);
    dispatch(updateCompany({ ...company, industries }, isAdmin));
  };

  const { formik, values, onChange, onBlur, onSubmit, dirty } = useForm({
    initialValues,
    onSubmit: handleSubmit,
  });

  const hasChanges = () => !equals(initialValues, values);

  useDetectDiffInChanges(hasChanges, onSubmit, setActiveSettingType);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={onSubmit}>
        <DisplayFlexS flexWrapScreenTablet="wrap" justifyScreenMedium="center">
          <SelectsArray
            renderAddNewFieldBtn={(index) =>
              path(['industries'], values).length === index + 1 && path(['industries'], values).length < 5
            }
            transKeyBase="companyIndustries"
            selectName="industries"
            options={staticCompanyValues.industries}
            valuesPath={['industries']}
            values={values}
            onChange={onChange}
            onBlur={onBlur}
          />
          <FieldComment
            transPath="companyEdit.fieldComment.industries"
            maxWidth="50%"
            marginTopScreenTablet="0px"
            marginBottomScreenTablet="20px"
          />
        </DisplayFlexS>

        <SaveButtonWrapper marginTop="30" marginTopMobile="90">
          <SaveBtn loading={loading} disabled={!dirty && !hasChanges(values)} />
        </SaveButtonWrapper>
      </form>
    </FormikProvider>
  );
};

export default IndustrySettings;
